import React, { useEffect, useState } from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
import { useHistory } from "react-router-dom";
import { localeFunction } from "src/utils/index";

const useStyles = makeStyles((theme) => ({
  acceptBtn: {
    fontSize: "14px",
    color: "green",
  },
  rejectBtn: {
    fontSize: "14px",
    color: "red",
  },
}));

export default function NotificationAlertPopUp({
  open,
  setOpen,
  data,
  notification,
}) {
  console.log("🚀 ~ notification:", notification);
  console.log("🚀 ~ notificationdata:", data);
  console.log("🚀 ~ setOpen:", setOpen);
  console.log("🚀 ~ open:", open);
  const [snackPack, setSnackPack] = useState([]);
  const [messageInfo, setMessageInfo] = useState(undefined);
  const historyComp = useHistory();

  useEffect(() => {
    if (snackPack.length && !messageInfo) {
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };

  const navigateToWebVoice = () => {
    historyComp.push({
      pathname: "/webvoice",
      state: {
        token: data?.token,
        channel: data?.channelId,
      },
    });
  };

  const classes = useStyles();
  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        autoHideDuration={null}
        onClose={handleClose}
        style={{ marginTop: "20px" }}
        ContentProps={{
          style: {
            backgroundColor: "#2d2d2d",
            color: "#fff",
            padding: "16px 20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
            minWidth: "320px",
            maxWidth: "400px",
          },
        }}
        message={
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            {/* Title */}
            <Typography
              variant="h6"
              style={{
                color: "#fff",
                fontSize: "16px",
                fontWeight: 600,
                marginBottom: "12px",
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {notification ? notification.title : "Voice Calling..."}
              {/* Notification Status Indicator */}
              <span
                style={{
                  display: "inline-block",
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#4caf50",
                  animation: "pulse 2s infinite",
                }}
              />
              <style>
                {`
                  @keyframes pulse {
                    0%, 100% {
                      opacity: 1;
                      transform: scale(1);
                    }
                    50% {
                      opacity: 0.5;
                      transform: scale(1.2);
                    }
                  }
                `}
              </style>
            </Typography>

            {/* Profile Picture and Message */}
            <Box
              display="flex"
              alignItems="center"
              style={{ marginBottom: "16px" }}
            >
              <img
                src={
                  data?.profilePic
                    ? data?.profilePic
                    : "images/user_placeholder.jpg"
                }
                alt="Profile"
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  marginRight: "12px",
                  objectFit: "cover",
                  border: "2px solid #444",
                }}
                onError={(e) => {
                  e.target.src = "images/user_placeholder.jpg";
                }}
              />
              <Typography
                variant="body1"
                style={{
                  color: "#fff",
                  fontSize: "14px",
                  flex: 1,
                }}
              >
                {notification?.body
                  ? notification.body
                  : `${data?.name || "User"} is calling...`}
              </Typography>
            </Box>

            {/* Action Buttons */}
            {data?.callType && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  gap: "12px",
                  marginTop: "8px",
                }}
              >
                <IconButton
                  aria-label="accept"
                  onClick={() => {
                    if (data.callType === "Video") {
                      historyComp.push({
                        pathname: "/webvideo",
                        state: {
                          token: data?.token,
                          channel: data?.channelId,
                        },
                      });
                      handleClose();
                    } else {
                      navigateToWebVoice();
                      handleClose();
                    }
                  }}
                  style={{
                    backgroundColor: "#4caf50",
                    color: "#fff",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#45a049";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#4caf50";
                  }}
                >
                  <DoneIcon style={{ marginRight: "6px", fontSize: "20px" }} />
                  {localeFunction("my_Post_text_5") || "Accept"}
                </IconButton>
                <IconButton
                  aria-label="decline"
                  onClick={handleClose}
                  style={{
                    backgroundColor: "#f44336",
                    color: "#fff",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#da190b";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#f44336";
                  }}
                >
                  <CloseIcon style={{ marginRight: "6px", fontSize: "20px" }} />
                  {localeFunction("my_Post_text_6") || "Decline"}
                </IconButton>
              </div>
            )}
            {!data?.callType && (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  style={{
                    color: "#fff",
                    padding: "4px",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            )}
          </div>
        }
      />
    </div>
  );
  console.log("🚀 ~ data:", data);
}
